/* JDM Engine Bay – theme scripts (no dependencies) */
(function () {
  'use strict';

  var theme = window.theme || { routes: { root: '/' }, strings: {} };
  var root = (theme.routes && theme.routes.root) || '/';
  if (root.slice(-1) !== '/') root += '/';
  var str = theme.strings || {};

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(amount) {
    var value = Number(amount);
    if (isNaN(value)) return amount;
    var format = theme.moneyFormat || '${{amount}}';
    var withDelimiters = function (n, decimals, thousands, decimal) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelimiters(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(value, 0, '.', ',');
        default: return withDelimiters(value, 2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count > 0 ? count : ''; });
  }

  /* ---------- Drawer (mobile menu) ---------- */
  function openDrawer(id) {
    var drawer = document.getElementById(id);
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    $$('[data-drawer-open="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var close = $('[data-drawer-close].drawer__close', drawer);
    if (close) close.focus();
  }
  function closeDrawers() {
    $$('[data-drawer].is-open').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      $$('[data-drawer-open="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    });
    document.body.classList.remove('drawer-open');
  }

  /* ---------- Modal ---------- */
  function openModal(id) {
    var modal = document.getElementById(id);
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    var first = $('input, select, button', $('.modal__body', modal) || modal);
    if (first) first.focus();
  }
  function closeModals() {
    $$('[data-modal].is-open').forEach(function (m) {
      m.classList.remove('is-open');
      m.setAttribute('aria-hidden', 'true');
    });
    document.body.classList.remove('drawer-open');
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var opener = t.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open')); return; }
    if (t.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawers(); return; }
    var modalOpener = t.closest('[data-modal-open]');
    if (modalOpener) { e.preventDefault(); openModal(modalOpener.getAttribute('data-modal-open')); return; }
    if (t.closest('[data-modal-close]')) { e.preventDefault(); closeModals(); return; }

    var filtersToggle = t.closest('[data-filters-toggle]');
    if (filtersToggle) {
      var box = filtersToggle.closest('[data-filters]');
      var open = box.classList.toggle('is-open');
      filtersToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }

    var thumb = t.closest('[data-gallery-thumb]');
    if (thumb) {
      var gallery = thumb.closest('[data-gallery]');
      var main = $('[data-gallery-main]', gallery);
      if (main) {
        main.src = thumb.getAttribute('data-src');
        main.srcset = thumb.getAttribute('data-srcset');
      }
      $$('[data-gallery-thumb]', gallery).forEach(function (b) { b.removeAttribute('aria-current'); });
      thumb.setAttribute('aria-current', 'true');
      return;
    }

    var minus = t.closest('[data-qty-minus]');
    var plus = t.closest('[data-qty-plus]');
    if (minus || plus) {
      var wrap = (minus || plus).closest('[data-qty]');
      var input = $('input', wrap);
      var min = input.hasAttribute('min') ? parseInt(input.min, 10) : 0;
      var max = input.hasAttribute('max') ? parseInt(input.max, 10) : Infinity;
      var v = parseInt(input.value, 10) || 0;
      v = minus ? Math.max(min, v - 1) : Math.min(max, v + 1);
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    var recover = t.closest('[data-toggle-recover]');
    if (recover) {
      e.preventDefault();
      var login = document.getElementById('LoginCard');
      var rec = document.getElementById('RecoverCard');
      if (login && rec) { login.hidden = !login.hidden; rec.hidden = !rec.hidden; }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawers(); closeModals(); }
  });

  /* ---------- Auto-submit (filters, sort, cart quantity) ---------- */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-autosubmit]')) {
      var form = t.form;
      if (form) form.submit();
    }
    if (t.matches('[data-cart-qty]')) {
      var cartForm = t.form;
      var btn = cartForm && $('[data-cart-update]', cartForm);
      if (btn) {
        clearTimeout(t._timer);
        t._timer = setTimeout(function () {
          if (cartForm.requestSubmit) cartForm.requestSubmit(btn); else btn.click();
        }, 500);
      }
    }
  });

  /* ---------- Vehicle finder ---------- */
  function initFinder(box) {
    if (box.getAttribute('data-finder-ready') === 'true') return;
    box.setAttribute('data-finder-ready', 'true');
    var form = $('[data-finder-form]', box);
    var year = $('[data-finder-year]', box);
    var make = $('[data-finder-make]', box);
    var model = $('[data-finder-model]', box);
    var models = [];
    try { models = JSON.parse(($('[data-finder-models]', box) || {}).textContent || '[]'); } catch (err) { models = []; }

    function fillModels() {
      var opt = make.options[make.selectedIndex];
      var makeName = opt ? (opt.getAttribute('data-make') || '') : '';
      model.innerHTML = '';
      var first = document.createElement('option');
      first.value = '';
      first.textContent = str.selectModel || 'Select Model';
      if (!makeName) {
        model.appendChild(first);
        model.disabled = true;
        return;
      }
      model.appendChild(first);
      var seen = {};
      models
        .filter(function (m) { return m.make === makeName; })
        .sort(function (a, b) { return a.model.localeCompare(b.model, undefined, { numeric: true, sensitivity: 'base' }); })
        .forEach(function (m) {
          if (seen[m.value]) return;
          seen[m.value] = true;
          var o = document.createElement('option');
          o.value = m.value;
          o.textContent = m.model;
          model.appendChild(o);
        });
      model.disabled = model.options.length <= 1;
    }

    make.addEventListener('change', fillModels);
    fillModels();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var base = (box.getAttribute('data-collection-url') || (root + 'collections/all')).replace(/\/$/, '');
      var tags = [year.value, make.value, model.value].filter(Boolean);
      window.location.href = tags.length ? base + '/' + tags.join('+') : base;
    });
  }

  /* ---------- Country / province selects ---------- */
  function initCountryProvince(countrySelect, provinceSelect, provinceWrapper) {
    function setProvinces() {
      var opt = countrySelect.options[countrySelect.selectedIndex];
      var provinces = [];
      try { provinces = JSON.parse(opt ? opt.getAttribute('data-provinces') || '[]' : '[]'); } catch (err) { provinces = []; }
      provinceSelect.innerHTML = '';
      provinces.forEach(function (p) {
        var o = document.createElement('option');
        o.value = p[0];
        o.textContent = p[1];
        provinceSelect.appendChild(o);
      });
      var def = provinceSelect.getAttribute('data-default');
      if (def) provinceSelect.value = def;
      var wrapper = provinceWrapper || provinceSelect.closest('.field');
      if (wrapper) wrapper.style.display = provinces.length ? '' : 'none';
    }
    var defCountry = countrySelect.getAttribute('data-default');
    if (defCountry) {
      for (var i = 0; i < countrySelect.options.length; i++) {
        if (countrySelect.options[i].value === defCountry || countrySelect.options[i].textContent === defCountry) {
          countrySelect.selectedIndex = i; break;
        }
      }
    }
    countrySelect.addEventListener('change', function () { provinceSelect.removeAttribute('data-default'); setProvinces(); });
    setProvinces();
  }

  /* ---------- Shipping estimator ---------- */
  function initEstimator(box) {
    var country = $('[data-estimator-country]', box);
    var province = $('[data-estimator-province]', box);
    var zip = $('[data-estimator-zip]', box);
    var submit = $('[data-estimator-submit]', box);
    var output = $('[data-estimator-output]', box);
    var variantId = box.getAttribute('data-variant-id');
    initCountryProvince(country, province, $('[data-estimator-province-wrapper]', box));

    function show(html, isError) {
      output.innerHTML = html;
      var msg = $('.estimator__message', output);
      if (msg && isError) msg.classList.add('is-error');
    }

    function ensureInCart() {
      if (!variantId) return Promise.resolve(false);
      return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var inCart = cart.items.some(function (i) { return String(i.variant_id) === String(variantId); });
          if (inCart) return false;
          return fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
          }).then(function (r) {
            if (!r.ok) throw new Error('add');
            return fetch(root + 'cart.js').then(function (r2) { return r2.json(); }).then(function (c) { updateCartCount(c.item_count); return true; });
          });
        });
    }

    submit.addEventListener('click', function () {
      submit.disabled = true;
      show('<p class="estimator__message">' + (str.loading || 'Loading…') + '</p>');
      var params = new URLSearchParams();
      params.set('shipping_address[zip]', zip.value.trim());
      params.set('shipping_address[country]', country.value);
      params.set('shipping_address[province]', province.value || '');
      ensureInCart()
        .then(function (added) {
          return fetch(root + 'cart/shipping_rates.json?' + params.toString(), { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data, added: added }; }); });
        })
        .then(function (res) {
          if (!res.ok) {
            var errs = [];
            Object.keys(res.data || {}).forEach(function (k) { [].concat(res.data[k]).forEach(function (m) { errs.push(k.replace(/_/g, ' ') + ' ' + m); }); });
            show('<p class="estimator__message">' + (errs.join('<br>') || str.shippingError) + '</p>', true);
            return;
          }
          var rates = (res.data && res.data.shipping_rates) || [];
          var html = '';
          if (!rates.length) {
            html = '<p class="estimator__message">' + (str.shippingNoRates || '') + '</p>';
          } else {
            html = '<ul class="estimator__results">' + rates.map(function (rate) {
              var price = Number(rate.price) === 0 ? (str.shippingFree || 'Free') : formatMoney(rate.price);
              return '<li><span>' + rate.name + '</span><strong>' + price + '</strong></li>';
            }).join('') + '</ul>';
          }
          if (res.added) html += '<p class="estimator__message" style="margin-top:.5rem;">' + (str.shippingAdded || '') + '</p>';
          show(html);
        })
        .catch(function () { show('<p class="estimator__message">' + (str.shippingError || 'Error') + '</p>', true); })
        .then(function () { submit.disabled = false; });
    });
  }

  /* ---------- Product recommendations ---------- */
  function initRecommendations(el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var tmp = document.createElement('div');
        tmp.innerHTML = text;
        var fresh = tmp.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim().length) el.innerHTML = fresh.innerHTML;
        else el.style.display = 'none';
      })
      .catch(function () { el.style.display = 'none'; });
  }


  /* ---------- Product media gallery + full-screen viewer ---------- */
  function initProductGallery(root) {
    if (root.getAttribute('data-pgallery-ready') === 'true') return;
    root.setAttribute('data-pgallery-ready', 'true');
    var track = $('[data-pgallery-track]', root);
    var slides = track ? $$('[data-pgallery-slide]', track) : [];
    var thumbs = $$('[data-pgallery-thumb]', root);
    var prev = $('[data-pgallery-prev]', root);
    var next = $('[data-pgallery-next]', root);
    var current = $('[data-pgallery-current]', root);
    var index = 0;

    function setActive(i) {
      index = Math.max(0, Math.min(slides.length - 1, i));
      if (current) current.textContent = index + 1;
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
      thumbs.forEach(function (t) {
        var on = Number(t.getAttribute('data-pgallery-thumb')) === index;
        if (on) {
          t.setAttribute('aria-current', 'true');
          var list = t.closest('[data-pgallery-thumbs]');
          if (list) {
            var li = t.parentNode;
            var left = li.offsetLeft - (list.clientWidth - li.offsetWidth) / 2;
            list.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
          }
        } else {
          t.removeAttribute('aria-current');
        }
      });
      slides.forEach(function (sl, n) {
        var v = sl.querySelector('video');
        if (v && n !== index && !v.paused) v.pause();
      });
    }

    function goTo(i, smooth) {
      if (!track || !slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      setActive(i);
    }

    if (track) {
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          var w = track.clientWidth || 1;
          var i = Math.round(track.scrollLeft / w);
          if (i !== index) setActive(i);
        });
      }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); }
      });
    }
    if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(Number(t.getAttribute('data-pgallery-thumb'))); });
    });
    window.addEventListener('resize', function () { goTo(index, false); });
    setActive(0);

    /* Full-screen viewer */
    var box = $('[data-lightbox]', root);
    if (!box) return;
    var images = [];
    try { images = JSON.parse(($('[data-pgallery-images]', root) || {}).textContent || '[]'); } catch (err) { images = []; }
    if (!images.length) return;
    document.body.appendChild(box); /* keep it above sticky header and outside the gallery */
    var img = $('[data-lightbox-img]', box);
    var counter = $('[data-lightbox-counter]', box);
    var lbPrev = $('[data-lightbox-prev]', box);
    var lbNext = $('[data-lightbox-next]', box);
    var pos = 0;
    var lastFocus = null;

    function preload(n) { if (images[n]) { var im = new Image(); im.src = images[n].src; } }
    function show(n) {
      pos = (n + images.length) % images.length;
      img.src = images[pos].src;
      img.alt = images[pos].alt || '';
      if (counter) counter.textContent = (pos + 1) + ' / ' + images.length;
      var single = images.length < 2;
      lbPrev.hidden = single; lbNext.hidden = single;
      preload(pos + 1); preload(pos - 1);
    }
    function open(slideIndex) {
      var n = 0;
      images.forEach(function (im, k) { if (im.index === slideIndex) n = k; });
      lastFocus = document.activeElement;
      box.hidden = false;
      document.body.classList.add('drawer-open');
      show(n);
      $('[data-lightbox-close]', box).focus();
    }
    function close() {
      box.hidden = true;
      document.body.classList.remove('drawer-open');
      var target = images[pos] ? images[pos].index : index;
      goTo(target, false);
      var back = $('[data-pgallery-open="' + target + '"]', root) || lastFocus; /* keep the gallery on this photo: focus without scrolling */
      if (back) back.focus({ preventScroll: true });
    }

    $$('[data-pgallery-open]', root).forEach(function (btn) {
      btn.addEventListener('click', function () { open(Number(btn.getAttribute('data-pgallery-open'))); });
    });
    $('[data-lightbox-close]', box).addEventListener('click', close);
    lbPrev.addEventListener('click', function () { show(pos - 1); });
    lbNext.addEventListener('click', function () { show(pos + 1); });
    box.addEventListener('lightbox:goto', function (e) { show(Number(e.detail) || 0); }); /* thumbnail strip: assets/lightbox-thumbs.js */
    box.addEventListener('click', function (e) { if (e.target === box || e.target.classList.contains('lightbox__figure')) close(); });
    document.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(pos - 1);
      if (e.key === 'ArrowRight') show(pos + 1);
    });
    var startX = null;
    box.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) show(pos + (dx < 0 ? 1 : -1));
      startX = null;
    });
  }

  /* ---------- Vehicle finder inside the hero ---------- */
  function placeFinders() {
    var slot = document.querySelector('[data-hero-finder-slot]');
    if (!slot) return;
    $$('.finder--hero[data-vehicle-finder]').forEach(function (box) {
      if (box.closest('[data-hero-finder-slot]')) return;
      if (slot.querySelector('[data-vehicle-finder]')) return;
      slot.appendChild(box);
      var home = document.getElementById(box.getAttribute('data-finder-home'));
      if (home) home.classList.add('is-moved');
    });
  }

  document.addEventListener('shopify:section:unload', function (e) {
    var target = e.target;
    /* The finder section is being re-rendered: drop its copy that lives in the hero */
    $$('[data-hero-finder-slot] [data-vehicle-finder]').forEach(function (box) {
      var home = document.getElementById(box.getAttribute('data-finder-home'));
      if (home && target.contains(home) && !target.contains(box)) box.parentNode.removeChild(box);
    });
    /* The hero is being re-rendered: send the finder back to its own section first */
    $$('[data-hero-finder-slot] [data-vehicle-finder]', target).forEach(function (box) {
      var home = document.getElementById(box.getAttribute('data-finder-home'));
      if (!home) return;
      home.classList.remove('is-moved');
      ($('.container', home) || home).appendChild(box);
    });
  });

  /* ---------- Init ---------- */
  function init() {
    $$('[data-pgallery]').forEach(initProductGallery);
    placeFinders();
    $$('[data-vehicle-finder]').forEach(initFinder);
    $$('[data-shipping-estimator]').forEach(initEstimator);
    $$('[data-address-country]').forEach(function (c) {
      var form = c.closest('form');
      var p = form && $('[data-address-province]', form);
      if (p) initCountryProvince(c, p);
    });
    $$('[data-recommendations]').forEach(function (el) { if (!el.children.length) initRecommendations(el); });
    $$('#ContactForm').forEach(function (form) {
      form.addEventListener('submit', function () {
        var btn = $('[data-sending-label]', form);
        if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-sending-label'); }
      });
    });
    if (document.querySelector('.template-customers-login') && window.location.hash === '#RecoverCard') {
      var login = document.getElementById('LoginCard');
      var rec = document.getElementById('RecoverCard');
      if (login && rec) { login.hidden = true; rec.hidden = false; }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Theme editor: re-init sections when they reload */
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-pgallery]', e.target).forEach(initProductGallery);
    placeFinders();
    $$('[data-vehicle-finder]').forEach(initFinder);
    $$('[data-shipping-estimator]', e.target).forEach(initEstimator);
  });
})();
